const GET_DOMAIN = window.location.href;
const LOCAL_ENV = {
    url: {
        REDIRECT_URL: 'http://localhost:8099/',
        ACQ_URL: 'http://localhost:3002/',
        KEYCLOAK_CLIENT: 'eir-myaccount-frontend',
        KEYCLOAK_TOKEN_URL:
            'https://keycloak.e2e.ion.comhar.local/auth/realms/customer/protocol/openid-connect/token',
        REALEX_HPP_URL: 'https://pay.sandbox.elavonpaymentgateway.com/pay',
        SWEEPR_APPLICATION: 'https://support.stagingeir.sweepr.com',
        SWEEPR_WIDGET_CSS: 'https://support.stagingeir.sweepr.com/assets/widget/widget.css',
        SWEEPR_WIDGET_JS: 'https://support.stagingeir.sweepr.com/assets/widget/widget.js',
        SUPPORT_REDIRECT_URL: 'https://testwww02.eir.ie/helpandsupport',
    },
};
const DEV_ENV = {
    url: {
        REDIRECT_URL: 'http://myeir-dev.eir.ie/',
        ACQ_URL: 'https://testwww04.eir.ie/',
        KEYCLOAK_CLIENT: 'eir-myaccount-frontend',
        KEYCLOAK_TOKEN_URL:
            'https://keycloak.e2e.ion.comhar.local/auth/realms/customer/protocol/openid-connect/token',
        REALEX_HPP_URL: 'https://pay.sandbox.elavonpaymentgateway.com/pay',
        SWEEPR_APPLICATION: 'https://support.stagingeir.sweepr.com',
        SWEEPR_WIDGET_CSS: 'https://support.stagingeir.sweepr.com/assets/widget/widget.css',
        SWEEPR_WIDGET_JS: 'https://support.stagingeir.sweepr.com/assets/widget/widget.js',
        SUPPORT_REDIRECT_URL: 'https://testwww04.eir.ie/helpandsupport',
    },
};
const TEST_ENV = {
    url: {
        REDIRECT_URL: 'http://myeir-test02.eir.ie/',
        ACQ_URL: 'https://testwww03.eir.ie/',
        KEYCLOAK_CLIENT: 'eir-myaccount-frontend',
        KEYCLOAK_TOKEN_URL:
            'https://keycloak.e2e.ion.comhar.local/auth/realms/customer/protocol/openid-connect/token',
        REALEX_HPP_URL: 'https://pay.sandbox.elavonpaymentgateway.com/pay',
        SWEEPR_APPLICATION: 'https://support.stagingeir.sweepr.com',
        SWEEPR_WIDGET_CSS: 'https://support.stagingeir.sweepr.com/assets/widget/widget.css',
        SWEEPR_WIDGET_JS: 'https://support.stagingeir.sweepr.com/assets/widget/widget.js',
        SUPPORT_REDIRECT_URL: 'https://testwww04.eir.ie/helpandsupport',
    },
};
const PRE_PROD = {
    url: {
        REDIRECT_URL: 'http://myeir-preprod.eir.ie/',
        ACQ_URL: 'https://testwww03.eir.ie/',
        KEYCLOAK_CLIENT: 'eir-myaccount-frontend',
        KEYCLOAK_TOKEN_URL:
            'https://keycloak.e2e.ion.comhar.local/auth/realms/customer/protocol/openid-connect/token',
        REALEX_HPP_URL: 'https://pay.sandbox.elavonpaymentgateway.com/pay',
        SWEEPR_APPLICATION: 'https://support.stagingeir.sweepr.com',
        SWEEPR_WIDGET_CSS: 'https://support.stagingeir.sweepr.com/assets/widget/widget.css',
        SWEEPR_WIDGET_JS: 'https://support.stagingeir.sweepr.com/assets/widget/widget.js',
        SUPPORT_REDIRECT_URL: 'https://testwww03.eir.ie/helpandsupport',
    },
};
const PROD_ENV = {
    url: {
        REDIRECT_URL: 'https://my.eir.ie/',
        ACQ_URL: 'https://eir.ie/',
        KEYCLOAK_CLIENT: 'eir-myaccount-frontend',
        KEYCLOAK_TOKEN_URL:
            'https://keycloak.e2e.ion.comhar.local/auth/realms/customer/protocol/openid-connect/token',
        REALEX_HPP_URL: 'https://pay.elavonpaymentgateway.com/pay',
        // TBU with PROD URL's
        SWEEPR_APPLICATION: 'https://support.prodeir.sweepr.com',
        SWEEPR_WIDGET_CSS: 'https://support.prodeir.sweepr.com/assets/widget/widget.css',
        SWEEPR_WIDGET_JS: 'https://support.prodeir.sweepr.com/assets/widget/widget.js',
        SUPPORT_REDIRECT_URL: 'https://www.eir.ie/helpandsupport',
    },
};

// export const MY_EIR_CONST =
//     GET_DOMAIN.indexOf('mytt') > 0 || GET_DOMAIN.indexOf('myeir-test') > 0
//         ? TEST_ENV // if test env
//         : GET_DOMAIN.indexOf('localhost') > 0
//         ? LOCAL_ENV // change DEV_ENV for development env or PROD_ENV for production
//         : GET_DOMAIN.indexOf('myeir-dev') > 0
//         ? DEV_ENV
//         : PROD_ENV; // if prod env

export const ACQUISITION = {
    url: {
        REDIRECT_URL: 'https://eir.ie',
    },
};

/* My eir to eir.ie */
export const MY_EIR_CONST = (() => {
    switch (true) {
        case GET_DOMAIN.indexOf('myeir-preprod') > 0:
            return PRE_PROD;
        case GET_DOMAIN.indexOf('mytt') > 0 || GET_DOMAIN.indexOf('myeir-test') > 0:
            return TEST_ENV;
        case GET_DOMAIN.indexOf('localhost') > 0:
            return LOCAL_ENV;
        case GET_DOMAIN.indexOf('myeir-dev') > 0:
            return DEV_ENV;
        default:
            return PROD_ENV;
    }
})();

export const DOMAINS = {
    VOIP: 'VOIP',
    FIBER: 'FIBER',
    DSL: 'DSL',
    MOBILE: 'MOBILE',
    IPTV: 'IPTV',
};
export const SERVICE_GROUPS = {
    MOBILE: 'MOBILE',
    MBB: 'MBB',
    TV: 'TV',
    DUALPLAY: 'DUALPLAY',
    SA_PSTN: 'SA_PSTN',
    DUALPLAY_PSTN: 'DUALPLAY_PSTN',
};

export const BROADBAND_TECHNOLOGY = {
    NBI: 'NBI',
};

export const ACCOUNT_STATUS = {
    BILLABLE: 'BILLABLE',
    INITIAL: 'INITIAL',
    BILLABLE_EMPTY: 'BILLABLE_EMPTY',
    UNBILLABLE: 'UNBILLABLE',
};
export const ADDON_STATUS = {
    ONGOING_TERMINATION: 'ONGOING_TERMINATION',
    NO_ONGOING_REQUEST: 'NO_ONGOING_REQUEST',
    ONGOING_ADDITION: 'ONGOING_ADDITION',
};

export const CHANNEL = 'MYEIR';
export const PAYMENT_GATEWAY_SELECTOR = {
    ELAVON: 'ELAVON',
    STANCER: 'STANCER',
};

/* Stancer payment origin */
export const PAYMENT_STANCER_URL = 'https://payment.stancer.com';

/* Stancer payment processing status */
export const STANCER_PAYMENT_STATUS = {
    ERROR: 'error',
    INIT: 'init',
    INVALID: 'invalid',
    FINISHED: 'finished',
    PENDING: 'pending',
    SECURE_AUTH_END: 'secure-auth-end',
    SECURE_AUTH_ERROR: 'secure-auth-error',
    SECURE_AUTH_START: 'secure-auth-start',
};

export const PAYMENT_METHOD_TYPE = {
    CREDIT_CARD: 'CREDIT_CARD',
};

export const SERVICES = {
    BROADBAND_LANDLINE: 'BROADBAND_LANDLINE',
    BROADBAND_LANDLINE_TV: 'BROADBAND_LANDLINE_TV',
    BROADBAND_LANDLINE_MOBILE: 'BROADBAND_LANDLINE_MOBILE',
    BROADBAND_LANDLINE_TV_MOBILE: 'BROADBAND_LANDLINE_TV_MOBILE',
    MOBILE: 'MOBILE',
    MBB: 'MBB',
};
export const ACTIONS = {
    SWEEPR_TROUBLESHOOT: 'SWEEPR_TROUBLESHOOT',
    GENERIC_REDIRECT: 'GENERIC_REDIRECT',
    GENERIC_CALL_DIALER: 'GENERIC_CALL_DIALER',
};

export const SYSTEM = {
    MY_EIR: 'myeir',
};
export const RECAPTCHA_KEY_V3 = '6Le2qgUqAAAAABvwuaR9zreIQJqB9R6_TIozGGHQ';

export const ESIM_STATUS = ['DOWNLOADED', 'INSTALLED', 'ENABLED', 'DELETED'];
